import { useBoolean } from "@/hooks/use-boolean";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@babackapp/ui/components/dialog";
import useTranslation from "@babackapp/translations/use-translation";
import { PropsWithChildren, useCallback } from "react";
import { CarrierTransportForm } from "./carrier-transport-form";
import { useCarriersContext } from "../../use-carriers-context";
import { useInvalidateCarriersQuery } from "@babackapp/private-api-client/client/use-carriers-query";
import {
  CreateCarrierDto,
  UpdateCarrierDto,
  UpsCarrierPreferenceDto,
} from "@babackapp/private-api-client/types";

export const AddCarrierTransportDialog = ({ children }: PropsWithChildren) => {
  const t = useTranslation();
  const open = useBoolean(false);
  const { addOneCarrierTransport, addOneUpsCarrierTransport, shop } =
    useCarriersContext();
  const invalidateCarriers = useInvalidateCarriersQuery({ shopId: shop.id });
  const onSubmitAddCarrierTransport = useCallback((data: CreateCarrierDto) => {
    if (data.code.includes("ups")) {
      addOneUpsCarrierTransport({
        carrierType: data.code,
        accountNumber:
          ((data.credentials as UpsCarrierPreferenceDto)
            .accountNumber as string) || "",
      });
      return;
    }

    addOneCarrierTransport(data);
    open.setValue(false);
  }, []);

  const onFedexRegistrationComplete = useCallback(() => {
    invalidateCarriers();
    open.setValue(false);
  }, [invalidateCarriers, open]);

  return (
    <Dialog open={open.value} onOpenChange={open.setValue}>
      <DialogTrigger asChild>{children}</DialogTrigger>
      <DialogContent className="pt-10">
        <DialogHeader>
          <DialogTitle> {t("carrier.label")}</DialogTitle>
          <DialogDescription>{t("carrier.subLabel")}</DialogDescription>
        </DialogHeader>
        <CarrierTransportForm
          onSubmitUps={addOneUpsCarrierTransport}
          onSubmit={
            onSubmitAddCarrierTransport as (
              data: CreateCarrierDto | UpdateCarrierDto,
            ) => void
          }
          onFedexRegistrationComplete={onFedexRegistrationComplete}
        />
      </DialogContent>
    </Dialog>
  );
};
